import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { VVGarageService } from './vv-garage.service';

angular.module('app-lite.vv-garage', [])
  .service('vvGarageApi', downgradeInjectable(VVGarageService));
